export enum Element {
  BurnedSomething = "burned something",
  Reed = "reed",
  FishSoup = "fish soup",
  Koumiss = "koumiss",
  Surstromming = "surströmming",
  Bush = "bush",
  CottonCandy = "cotton candy",
  Eggnog = "eggnog",
  IceTea = "ice tea",
  Kvass = "kvass",
  Sushi = "sushi",
  Baklava = "baklava",
  Pilaf = "pilaf",
  Muesli = "muesli",
  Gozinaki = "gozinaki",
  Mead = "mead",
  Gingerbread = "gingerbread",
  Manure = "manure",
  Tree = "tree",
  Fondue = "fondue",
  CremeBrulee = "creme brulee",
  Croissant = "croissant",
  HotDog = "hot-dog",
  Hamburger = "hamburger",
  Popcorn = "popcorn",
  Communion = "communion",
  Beer = "beer",
  Vodka = "vodka",
  Brandy = "brandy",
  Liqueur = "liqueur",
  Cider = "cider",
  Soda = "soda",
  Cola = "cola",
  MulledWine = "mulled wine",
  GroundCoffee = "ground coffee",
  CocoaPowder = "cocoa powder",
  CocoaBean = "cocoa bean",
  CoffeeBean = "coffee bean",
  Shawerma = "shawerma",
  Animal = "animal",
  Earth = "earth",
  Furnace = "furnace",
  Ice = "ice",
  Tool = "tool",
  Bacteria = "bacteria",
  Egg = "egg",
  Meat = "meat",
  Milk = "milk",
  Water = "water",
  BoilingWater = "boiling water",
  Omelette = "omelette",
  Kebab = "kebab",
  Forcemeat = "forcemeat",
  Kefir = "kefir",
  Cream = "cream",
  Cheese = "cheese",
  BlueCheese = "blue cheese",
  BoiledEgg = "boiled egg",
  Roast = "roast",
  CondensedMilk = "condensed milk",
  Milkshake = "milkshake",
  Fish = "fish",
  Seed = "seed",
  Grass = "grass",
  Sugar = "sugar",
  Sausage = "sausage",
  Tea = "tea",
  Cutlet = "cutlet",
  Toffee = "toffee",
  IceCream = "ice cream",
  FriedFish = "fried fish",
  Cereal = "cereal",
  Mojito = "mojito",
  Spices = "spices",
  Flower = "flower",
  Caramel = "caramel",
  Syrup = "syrup",
  ButterDough = "butter dough",
  Flour = "flour",
  Porridge = "porridge",
  Berry = "berry",
  Sauce = "sauce",
  Nut = "nut",
  Honey = "honey",
  Candy = "candy",
  Cookie = "cookie",
  Pie = "pie",
  Cake = "cake",
  Dough = "dough",
  Juice = "juice",
  Wine = "wine",
  Jam = "jam",
  Yogurt = "yogurt",
  Marshmallow = "marshmallow",
  Mayonnaise = "mayonnaise",
  Fruit = "fruit",
  NutButter = "nut butter",
  Mustard = "mustard",
  Topping = "topping",
  Bread = "bread",
  Pita = "pita",
  Baozi = "baozi",
  Spaghetti = "spaghetti",
  Noodles = "noodles",
  Alcohol = "alcohol",
  Cocoa = "cocoa",
  Chocolate = "chocolate",
  Coffee = "coffee",
  Latte = "latte",
  Vegetable = "vegetable",
  Toast = "toast",
  Sandwich = "sandwich",
  HotChocolate = "hot chocolate",
  Eskimo = "eskimo",
  ChocolateBar = "chocolate bar",
  Muffin = "muffin",
  FrenchFries = "french fries",
  Salad = "salad",
  Soup = "soup",
  Ketchup = "ketchup",
}

export enum FoodType {
  Animal = "animal",
  Bakery = "bakery",
  Drink = "drink",
  Meat = "meat",
  Milk = "milk",
  Other = "other",
  Plant = "plant",
  Inedible = "inedible",
  Fastfood = "fastfood",
  Vegan = "vegan",
  Sweet = "sweet",
}

export type ElementEntriesType = [Element, FoodType];

export type RecipesType = [[Element, Element], Element | Element[]][];

export type RecipesByElementType = {
  [key in Element]?: {
    [key in Element]?: Element | Element[];
  };
};
